import { useGSAP } from "@gsap/react";
import { useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

function ProgressBar() {
  gsap.registerPlugin(useGSAP, ScrollTrigger);

  const scrollBarContainerRef = useRef<HTMLDivElement>(null);
  const scrollBarProgressRef = useRef<HTMLDivElement>(null);
  const scrollBarProgressContainerRef = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      gsap.to(scrollBarProgressRef.current, {
        scrollTrigger: {
          trigger: scrollBarContainerRef.current,
          scrub: 2,
          start: "top center",
        },
        height: "100%",
      });

      const steps = gsap.utils.toArray<HTMLElement>(".roadmap-card-step");
      steps.forEach((step) => {
        gsap.to(step, {
          backgroundColor: "rgb(34 197 94)",
          scrollTrigger: {
            trigger: step,
            start: "top 80%",
            scrub: 1,
          },
        });
      });
    },
    {
      dependencies: [scrollBarProgressRef, scrollBarContainerRef],
      revertOnUpdate: true,
    }
  ); // <-- scope is for selector text (optional)

  return (
    <div
      id="scrollbar-container"
      ref={scrollBarContainerRef}
      className=" h-full flex justify-center items-center w-20"
    >
      <div
        ref={scrollBarProgressContainerRef}
        className=" bg-[#26262a96] h-[80%] rounded-xl w-4 "
      >
        <div
          ref={scrollBarProgressRef}
          id="scrollbar-progress"
          className="  bg-green-400 rounded-xl  h-3  relative     w-full"
        ></div>
      </div>
    </div>
  );
}

export default ProgressBar;
